import { AppPanels } from "../../RouteProvider/lib/routeConfig"
import styles from "./styles.module.scss"
import bridge from "@vkontakte/vk-bridge"
import { Button, ModalCard, ModalRoot, SplitCol, SplitLayout } from "@vkontakte/vkui"
import { useUnit } from "effector-react"
import { ReactNode, memo, useCallback } from "react"
import { setActivePanel } from "src/entity/ActivePanel"
import { MessagesTypesT, clearMessage, messagesTypes } from "src/entity/Messages"
import { Mods, classNames } from "src/shared/lib/helpers/classNames"
import { SuperBtn } from "src/shared/ui/superBtn"

const modalMessages: Record<MessagesTypesT, string> = {
  [messagesTypes.FILL_ERROR]: "Заполните все поля",
  [messagesTypes.POST_ERROR]: "Что-то пошло не так, попробуйте снова немного позже",
  [messagesTypes.STATUS_ERROR]: "Выбрать свой эмодзи-статус можно после голосования за Главных Героев!",
  [messagesTypes.SHARE_POSTCARD_ERROR]: "Ошибка при загрузке изображения на сервер. Попробуйте еще раз.",
  [messagesTypes.SET_IMAGE_STATUS_SUCCESS]: "Ура! Статус успешно установлен",
  [messagesTypes.SET_CONGRAT_FORM]: "Спасибо за твой голос! \n\nОбязательно расскажи друзьям про премию «Главные герои», чтобы они тоже проголосовали!",
  [messagesTypes.SET_IMAGE_STATUS_ERROR]: "Ошибка при установке статуса изображения, попробуйте немного позже",
}

export interface IModal {
  messageType?: MessagesTypesT | null
  onClose?: () => void
}

export const ModalProvider = memo(({ messageType, onClose }: IModal) => {
  const onSetActivePanel = useUnit(setActivePanel)
  const [onClearMessage] = useUnit([clearMessage])

  // Актуально для второго этапа голосования
  const onStatusErrorActionClick = useCallback(() => {
    // @ts-ignore
    bridge.send("VKWebAppSendCustomEvent", {
      event: "vote_click",
      screen: "modal",
    })
    onSetActivePanel(AppPanels.SECOND_STAGE_NOMINATIONS)
    onClose?.()
  }, [onSetActivePanel, onClose])

  const handleClickSzuri = useCallback(() => {
    onClearMessage()
    onSetActivePanel(AppPanels.POST_CARD)
  }, [onSetActivePanel, onClose])

  if (!messageType) {
    return null
  }

  const actions: Record<MessagesTypesT, ReactNode[]> = {
    [messagesTypes.FILL_ERROR]: [],
    [messagesTypes.POST_ERROR]: [],
    [messagesTypes.SHARE_POSTCARD_ERROR]: [],
    [messagesTypes.SET_IMAGE_STATUS_SUCCESS]: [],
    [messagesTypes.SET_CONGRAT_FORM]: [
      <Button disabled={false} size="m" style={{ marginTop: "20px", zIndex: 99 }} className={`button-main button-main--pink button-main--submit`} onClick={handleClickSzuri}>
        Скачать диплом жюри
      </Button>,
    ],
    [messagesTypes.SET_IMAGE_STATUS_ERROR]: [],
    [messagesTypes.STATUS_ERROR]: [<SuperBtn text="Голосовать" color="3" key={1} onClick={onStatusErrorActionClick} />],
  }

  const mods: Mods = {
    [styles.success]: messageType.includes("success"),
  }

  const modals = (
    <ModalRoot activeModal="faq">
      <ModalCard className={classNames(styles.modal, mods)} onClose={onClose} id="faq" actions={actions[messageType]}>
        {messageType && modalMessages[messageType]}
      </ModalCard>
    </ModalRoot>
  )

  return (
    <SplitLayout id="layout" modal={modals}>
      <SplitCol id="col" />
    </SplitLayout>
  )
})
